module.exports = __webpack_public_path__ + "static/media/16023.1b37e397.jpg";